<template>
  <div class="audit">
    <div class="heatitle">
      <img src="../assets/u27942x.png" alt="" />
      <span>{{$t('Company')}}</span>{{ item.companyName }}
    </div>
    <div class="col-md-12 describe">
      <div class="col-md-6">
        <div class="describe-ms">
          <span>{{$t('ProductName')}}</span>{{ item.workName }}
        </div>
        <div class="describe-ms">
          <span>{{$t('CopyrightRegistration')}}</span>{{ item.copyrightRegistration }}
        </div>
        <div class="describe-ms">
          <span>{{$t('TimeToMarket')}}</span>{{ item.marketDate }}
        </div>
        <div class="describe-ms">
          <span>{{$t('PatentApplication')}}</span>{{ item.patent }}
        </div>
        <div class="describe-ms">
          <span>{{$t('designIntroduction')}}</span>{{ item.designDescription}}
        </div>
        <div class="describe-ms">
          <span>{{$t('postalAddress')}}</span>{{ item.postalAddress }}
        </div>
        <div class="describe-ms">
          <span>{{$t('ContactName')}}</span>{{ item.contactName }}
        </div>
        
        <!-- <div class="describe-ms">
          <span>{{$t('Price')}}</span>{{ item.productPrice }}
        </div>
        <div class="describe-ms">
          <span>{{$t('PatentNumber')}}</span>{{ item.productType }}
        </div>
        <div class="describe-ms">
          <span>{{$t('Specialprocess')}}</span>{{ item.patentNo }}
        </div>
        <div class="describe-ms">
          <span>{{$t('ProductBrand')}}</span>{{ item.productBrand }}
        </div>
        <div class="describe-ms">
          <span>{{$t('NetWeight')}}</span>{{ item.netWeight }}
        </div> -->
      </div>
      <div class="col-md-6">
        <div class="describe-ms">
          <span>{{$t('DesignCompletionDate')}}</span>{{ item.completionDate }}
        </div>
        <div class="describe-ms">
          <span>{{$t('job')}}</span>{{ item.post }}
        </div>
        <div class="describe-ms">
          <span>{{$t('fixedTelephone')}}</span>{{ item.fixedTelephone }}
        </div>
        <div class="describe-ms">
          <span>{{$t('email')}}</span>{{ item.email }}
        </div>
        
        <!-- <div class="describe-ms">
          <span>{{$t('Productsize')}}</span>{{ item.productSize }}
        </div>
        <div class="describe-ms">
          <span>{{$t('Manufacturingcompany')}}</span>{{ item.manufacturingCompany }}
        </div>
        <div class="describe-ms">
          <span>{{$t('SpecialMaterials')}}</span>{{ item.specialMaterials }}
        </div>
        <div class="describe-ms">
          <span>{{$t('Designhouse')}}</span>{{ item.designCompany }}
        </div> -->
      </div>
     
      <div class="col-md-12">
        <!-- <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('Productdescription')}}</span>
          <div style="margin-top: 10px">{{ item.productDescription }}</div>
        </div> -->
        <!-- <div class="describe-ms">
          <span>{{$t('Mainpicturesofproducts')}}</span>
          <div  style="width: 100%;">
            <div 
            style="padding: 5px 5px 5px 0;"
            v-for="(ite, index) in item.imgArr"
            :key="index"
            >
              <el-image
                :src="ite"
             ></el-image>
            </div>
          </div>
          
        </div> -->
         <div class="col-md-12 vedio">
        <div class="describe-ms">
          <span>{{$t('pvai')}}:</span>
        </div>

        <el-carousel
        class="carouselcarouselcarousel"
          style="max-width: 737px; max-height: 340px; background-color: rgba(106, 122, 130 , .4); position: relative"
          :autoplay="autoplay"
          :interval="interval"
          arrow="always"
          :initial-index="initialIndex"
          ref="carousel"
          indicator-position="none"
        >
          <el-carousel-item v-for="(item, index) in banner" style="display: flex;justify-content: center; " :key="item.id">
            <video-player
              class="video-player vjs-custom-skin"
              style="width: 100%"
              v-if="isVideo(item)"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @pause="pause"
              @play="onPlayerPlay($event)"
              @ended="onPlayerEnded($event)"
              @loadeddata="onPlayerLoadeddata($event)"
            >
            </video-player>
            <el-image
              class="vote-btn234 "
              v-else
              :src="item"
              style="height: 340px;"
              :preview-src-list="banner.slice(0,-1)"
              fit="cover"
            ></el-image>
            
            <img
              v-if="!isvideo && isVideo(item)"
              @click="clicks(index)"
              style="
                width: 52.48px;
                height: 52.48px;
                position: absolute;
                top: 50%;
                left: 50%;
                cursor: pointer;
                transform: translate(-50%, -50%);
              "
              src="../assets/20220906180356.png"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
        <div class="describe-ms" style="line-height: 25px; margin-bottom: 10px;">
          <span>{{$t('companyIntroduction')}}</span>{{ item.briefIntroduction }}
        </div>
        
        <div class="describe-ms">
          <span>{{$t('MobilePhone')}}</span>{{ item.mobilePhone }}
        </div>
        <div class="describe-ms">
          <span>{{$t('personnelInformation')}}</span>
          <div v-for="(ite,index) in item.personnelInformation" style="margin: 10px 0;" :key="index">
            <span style="display: inline-block; margin:0 10px 5px 0;">{{$t('name')}}</span>{{ite.name}}
            <span style="display: inline-block; margin:0 10px 5px 10px;">{{$t('Tel')}}:</span>{{ite.contactPhone}}
          </div>
        </div>
        <!-- <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('EnvironmentalPerformance')}}</span>
          <div style="margin-top: 10px">{{ item.environmentalProtection }}</div>
        </div>

        <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('Adaptabilitytospecialroadconditions')}}</span>
          <div style="margin-top: 10px">{{ item.roadConditions }}</div>
        </div>

        <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('DescriptionofOtherFeatures')}}</span>
          <div style="margin-top: 10px">{{ item.otherFeatures }}</div>
        </div>

        <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('Functionality')}}</span>
          <div style="margin-top: 10px">{{ item.loadCapacity }}</div>
        </div>

        <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('Convenience')}}</span>
          <div style="margin-top: 10px">{{ item.convenience }}</div>
        </div>

        <div class="describe-ms" style="margin-bottom: 30px">
          <span>{{$t('Security')}}</span>
          <div style="margin-top: 10px">{{ item.security }}</div>
        </div> -->
      </div>
      <div class="col-md-12" style="display: flex; justify-content: center">
        <div class="btns-s" v-if="item.auditStatus == 0">
          <div class="pass" @click="pass">{{$t('adoptBtn')}}</div>
          <div class="reject" @click="reject">{{$t('refuseBtn')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  data() {
    return {
      item: {},
      autoplay: false, //自动播放
      interval: NaN, //轮播时常
      initialIndex: 0, //从下标第几个开始轮播
      duration: NaN, //计算总时长,
      isvideo: false,
      nowIndex: 0,
      banner: [
        // {
        //   id: 1,
        //   img: "https://www.runoob.com/try/demo_source/movie.mp4",
        // },
        // {
        //   id: 2,
        //   img: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.jj20.com%2Fup%2Fallimg%2Ftp05%2F1Z9291T012CB-0-lp.jpg&refer=http%3A%2F%2Fimg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1665045432&t=38f3644eda983762842f3d76f9aa0ff6",
        // },
        // {
        //   id: 3,
        //   img: "http://vfx.mtime.cn/Video/2019/02/04/mp4/190204084208765161.mp4",
        // },
      ], //从后端获取来的轮播图数据

      //vue-video-play  播放器默认的设置
      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。实现自动播放，autoplay、muted都设置为true
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        width: 737, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        loading:false
      },
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  created() {
    console.log("1111", this.$route.query);
    if (this.$route.query.pid) {
      this.$getHttp("pc/Entries/getEntrieById", {
        id: this.$route.query.pid,
        type: 1,
      }).then((res) => {
        if (res.success) {
          var item = res.data;
          var banner = [];
          var i = 99;
          var temp = [
            "entriesPictures",
            // "productPicturesUse",
            // "productDesign",
            "productVideos",
            // "productReport",
            // "patentInvention",
            // "utilityModel",
            // "industrialDesign",
          ];
          for (var key of temp) {
            if (item[key]) {
              console.log(key)
              if (item[key].indexOf("|") > 0) {
              item.imgArr = [];
              item[key].split("|").map((item2) => {
                item.imgArr.push(this.$imgUrl + item2);
              });
              }else {
                // if (item[key].includes("MP")) {
                //   item[key].replace("MP","mp")
                // }
                item.imgArr.push(this.$imgUrl + item[key]);
              }
            }
          }
          this.banner = item.imgArr;
          this.banner.forEach(el=>{
            if (el.includes("MP")) {
             el = el.replace("MP","mp")
            }
          })
          console.log(this.banner)
          this.item = res.data;
          if(this.item.patent == "1"){
            console.log(this.item.patent)
            this.item.patent = "是"
          }else if(this.item.patent == "0"){
            this.item.patent =  "否"
          }
          if(this.item.copyrightRegistration == "1"){
            this.item.copyrightRegistration = "是"
          }else if(this.item.copyrightRegistration == "0"){
            this.item.copyrightRegistration = "否"
          }
          
          this.item.personnelInformation= JSON.parse(this.item.personnelInformation);
           this.getvideo();

        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    }
  },
  mounted() {},
  components: { videoPlayer },
  methods: {
    pass() {
      if(this.loading)return
      this.loading=true
      this.$postHttp("pc/Entries/audit", {
        id: this.item.id,
        status: 1,
      }).then((res) => {
        if (res.success) {
          this.$message({
            message: res.msg,
          });
          setTimeout(() => {
            this.$router.push({
              path: "/product",
            });
          }, 1000);
        } else {
          this.$message({
            message: res.msg,
          });
           this.loading=false
        }
      });
    },
    reject() {
      if(this.loading)return
      this.loading=true
      this.$postHttp("pc/Entries/audit", {
        id: this.item.id,
        status: 2,
      }).then((res) => {
        if (res.success) {
          this.$message({
            message: res.msg,
          });
          setTimeout(() => {
            this.$router.push({
              path: "/product",
            });
          }, 1000);
        } else {
          this.$message({
            message: res.msg,
          });
          this.loading=false
        }
      });
    },
    // 监听轮播图改变
    onChange(index) {
      // 如果是视频,就等播放完再进行下一个
      if (this.isVideo(this.banner[index].img)) {
        this.playerOptions["sources"][0]["src"] = this.banner[index].img; //把获取来的视频赋值给sources的src
        this.$refs.videoPlayer[0].player.src(
          this.playerOptions["sources"][0]["src"]
        ); // 重置进度条,再次轮播时让视频重新播放
        this.interval = this.duration * 1000;
        this.autoplay = false;
        this.nowIndex = index;
        this.$refs.videoPlayer.map((v, i) => {
          v.player.pause();
        });
        this.isvideo = false;
      }
    },
    getvideo() {
      console.log(2,this.banner)
      this.banner.forEach((val,index)=>{
        if (this.isVideo(this.banner[index])) {
          console.log(2,this.banner[index])
          if (val.includes("MP")) {
             val = val.replace("MP","mp")
            }
        this.playerOptions["sources"][0]["src"] = this.banner[index];
      }
      })
      
    },
    onPlayerEnded(player) {
      //视频播放停止时候触发的事件
      this.autoplay = true;
      this.interval = 3000;
      this.isvideo = false;
    },
    onPlayerLoadeddata(player) {
      // 获取资源总时长
      this.duration = player.cache_.duration;
    },
    onPlayerPlay(player) {
      player.play();
    },
    clicks(index) {
      let arr = this.banner.filter((v, i) => {
        return i < index && this.isVideo(v);
      });
      this.$refs.videoPlayer[arr.length].player.play();
      this.isvideo = true;
    },

    pause() {
      this.isvideo = false;
    },
  },
};
</script>

<style lang="less" scope>
.carouselcarouselcarousel{
  .el-carousel__container{
    height: 0 !important;
    padding-bottom: 43.99%;
}
}
.el-image-viewer__canvas{
  width: 40% !important;
  margin: 0 auto;
}
.audit {
  padding: 30px;
  .heatitle {
    display: flex;
    align-items: center;
    font-size: 22px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    img {
      width: 30px;
      height: 30px;
      margin-right: 8px;
    }
    span {
      color: #6f73f4;
      display: inline-block;
        margin-right: 10px;
    }
  }
  .describe {
    margin-left: 38px;
    margin-top: 26px;
    .describe-ms {
      // height: 25px;
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      margin-bottom: 20px;
      color: #333333;
      span {
        color: #6f73f4;
        display: inline-block;
        margin-right: 10px;
      }
    }
    .vedio {
      padding: 0;
      margin-bottom: 30px;
      .el-carousel__arrow {
        width: 40px;
        height: 40px;
        background: none;
      }
      .el-icon-arrow-left,
      .el-icon-arrow-right {
        font-size: 30px;
        font-weight: 600;
      }
      .vjs-big-play-button {
        display: none;
      }
    }
  }
  .btns-s {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 150px;
    margin-bottom: 79px;
    .pass {
      cursor: pointer;
      margin-bottom: 12px;
      width: 310px;
      height: 56px;
      background: #4eb56e;
      border-radius: 10px 10px 10px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 70px;
    }

    .reject {
      cursor: pointer;
      width: 310px;
          margin-bottom: 12px;
      height: 56px;
      background: #d37357;
      border-radius: 10px 10px 10px 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      
    }
  }
}
</style>